import CheckoutPage from "./component/checkoutorderPage";

const CheckoutOrderFocus = () => {
  return <CheckoutPage pageType="MMT" />;
};

export default CheckoutOrderFocus;
